import { render, staticRenderFns } from "./settingWorkDocsWorkArea.vue?vue&type=template&id=3eab0a3e&"
import script from "./settingWorkDocsWorkArea.vue?vue&type=script&lang=js&"
export * from "./settingWorkDocsWorkArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports